import { Validator } from "~/workera/utils/typedForms/validators/common/Validator";
import { ValidatorResponse } from "~/workera/utils/typedForms/validators/common/ValidatorResponse";

export abstract class StringValidator implements Validator<string> {
  abstract validate(s: string): ValidatorResponse;
}
